import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatAddress } from '../../../utils/mockDossierData';
import { resolveIntlLocale } from '../../../utils/locale';
import './DossierBusinessInfo.css';

export function DossierBusinessInfo({ dossier }) {
  const { t, i18n } = useTranslation();
  const locale = resolveIntlLocale(i18n.language);
  if (!dossier) return null;

  return (
    <div className="dossier-business-info">
      <h4 className="dossier-business-info__title">{t('reports.workspace.dossier.sections.businessInfo.title')}</h4>
      
      <div className="dossier-business-info__fields">
        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.cuaa')}</div>
          <div className="dossier-business-info__field-value">{dossier.cuaa || t('common.notAvailable')}</div>
        </div>

        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.legalForm')}</div>
          <div className="dossier-business-info__field-value">{dossier.legalForm || t('common.notAvailable')}</div>
        </div>

        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.businessName')}</div>
          <div className="dossier-business-info__field-value">{dossier.businessName || t('common.notAvailable')}</div>
        </div>

        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.officeAddress')}</div>
          <div className="dossier-business-info__field-value">
            {formatAddress(dossier.officeAddress)}
          </div>
        </div>

        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.payingAgency')}</div>
          <div className="dossier-business-info__field-value">{dossier.payingAgency || t('common.notAvailable')}</div>
        </div>

        <div className="dossier-business-info__field">
          <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.validationDate')}</div>
          <div className="dossier-business-info__field-value">
            {dossier.validationDate
              ? new Date(dossier.validationDate).toLocaleDateString(locale)
              : t('common.notAvailable')}
          </div>
        </div>

        {dossier.taxId && (
          <div className="dossier-business-info__field">
            <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.taxId')}</div>
            <div className="dossier-business-info__field-value">{dossier.taxId}</div>
          </div>
        )}

        {dossier.vatNumber && (
          <div className="dossier-business-info__field">
            <div className="dossier-business-info__field-label">{t('reports.workspace.dossier.sections.businessInfo.fields.vat')}</div>
            <div className="dossier-business-info__field-value">{dossier.vatNumber}</div>
          </div>
        )}
      </div>
    </div>
  );
}
